import { FormAppRelayInterface } from '@fusion-advantage/backcompat'

const _defaultInstance: Readonly<FormAppRelayInterface> = {
	updateRenderState() { throw new Error('not implemented') },
	updateUserLocation() { throw new Error('not implemented') },
	downloadFile() { throw new Error('not implemented') },
	uploadFile() { throw new Error('not implemented') },
	addNativePluginListener() { throw new Error('not implemented') },
	showRxScanner() { throw new Error('not implemented') },
	showBarcodeScanner() { throw new Error('not implemented') },
	queryDrugProducts() { throw new Error('not implemented') },
	queryIcdCodes() { throw new Error('not implemented') },
	queryIcdCodesByProductId() { throw new Error('not implemented') },
	selectDrugIcdCodes() { throw new Error('not implemented') },
	queryMaterialStatus() { throw new Error('not implemented') },
	queryUnfilteredIcds() { throw new Error('not implemented') },
	querySecondaryCodes() { throw new Error('not implemented') },
	exitForm() { throw new Error('not implemented') },
	saveFormDraft() { throw new Error('not implemented') },
	submitForm() { throw new Error('not implemented') },
}

let _instance: Readonly<FormAppRelayInterface>|null = null

export const setFormAppRelay = (instance: FormAppRelayInterface|null) => {
	_instance = instance
}

// this function doesn't do anything special to make it only a hook,
// so it can be used in other contexts, like inside Redux middleware
export const useFormAppRelay = (): Readonly<FormAppRelayInterface> => {
	return _instance ?? _defaultInstance
}
